import React, { useState } from "react";
import moment from "moment";
import PLANE from "../../assets/images/plane.png";
import Loading from "../../components/spinner/Loading";
import { getFlightImage } from "../../_helpers/flightUtils";
import { formatIndianNumber } from "../../_helpers/formatUtils";
import { formatMinToHRAndMin } from "../../_helpers/dateUtils";
import { FlightImage } from "../../components/flightimage/FlightImage";

interface FlightRDetailsTabsProps {
  route: any;
  routeIndex: number;
  openFightDetail: boolean;
  priceDetails: any;
  // classOfBook: string;
  // cabinClass: string;
  remainingSeats: number;
  getFareRules: (Fare_Id: string, Flight_Key: string) => void;
  ADULT: number;
  adultTaxRate: number;
  adultBaseRate: number;
  CHILD: number;
  childTaxRate: number;
  childBaseRate: number;
  INFANT: number;
  infantTaxRate: number;
  infantBaseRate: number;
  totalPrice: number;
  fareRulesLoading: boolean;
  fareRule: any;
  prefix: string;
  infantFreeBaggage: any;
  childFreeBaggage: any;
  adultFreeBaggage: any;
}

const FlightRDetailsTabs = ({
  openFightDetail,
  routeIndex,
  route,
  priceDetails,
  // classOfBook,
  // cabinClass,
  remainingSeats,
  getFareRules,
  ADULT,
  adultTaxRate,
  adultBaseRate,
  CHILD,
  childTaxRate,
  childBaseRate,
  INFANT,
  infantTaxRate,
  infantBaseRate,
  totalPrice,
  fareRule,
  fareRulesLoading,
  prefix,
  infantFreeBaggage,
  childFreeBaggage,
  adultFreeBaggage,
}: FlightRDetailsTabsProps) => {
  return (
    <div
      className={`flight-tabing-3 ${
        openFightDetail ? "flight-outer-open" : ""
      }`}
    >
      <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id={`pills-tab-flight-${routeIndex}-${prefix}`}
            data-bs-toggle="pill"
            data-bs-target={`#pills-flight-details-${routeIndex}-${prefix}`}
            type="button"
            role="tab"
            aria-controls={`pills-flight-details-${routeIndex}-${prefix}`}
            aria-selected="true"
          >
            Flight Details
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id={`pills-tab-fare-details-${routeIndex}-${prefix}`}
            data-bs-toggle="pill"
            data-bs-target={`#pills-fare-details-${routeIndex}-${prefix}`}
            type="button"
            role="tab"
            aria-controls={`pills-fare-details-${routeIndex}-${prefix}`}
            aria-selected="false"
            tabIndex={-1}
          >
            Fare Details
          </button>
        </li>
        {/* <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id={`pills-tab-fare-rules-${routeIndex}-${prefix}`}
            data-bs-toggle="pill"
            data-bs-target={`#pills-fare-rules-${routeIndex}-${prefix}`}
            type="button"
            role="tab"
            aria-controls={`pills-fare-rules-${routeIndex}-${prefix}`}
            aria-selected="false"
            tabIndex={-1}
            onClick={() => {
              getFareRules(priceDetails?.Fare_Id, route?.Flight_Key);
            }}
          >
            Fare Rules
          </button>
        </li> */}
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id={`pills-tab-buggage-details-${routeIndex}-${prefix}`}
            data-bs-toggle="pill"
            data-bs-target={`#pills-buggage-details-${routeIndex}-${prefix}`}
            type="button"
            role="tab"
            aria-controls={`pills-buggage-details-${routeIndex}-${prefix}`}
            aria-selected="false"
            tabIndex={-1}
          >
            Baggage Details
          </button>
        </li>
      </ul>
      <div className="tab-content" id="pills-tabContent">
        <div
          className="tab-pane fade active show"
          id={`pills-flight-details-${routeIndex}-${prefix}`}
          role="tabpanel"
          aria-labelledby={`pills-tab-flight-${routeIndex}-${prefix}`}
        >
          <div className="fligt-confirm">
            {route?.Segments?.map((e: any, index: number) => {
              const flightNo = e?.Flight_Number;
              const flightCode = e?.Airline_Code;
              const departureTime = e?.Departure_DateTime;
              const arivalTime = e?.Arrival_DateTime;
              // const layoverTime = e?.cT || 1;
              const duration = e?.Duration;
              const arivalCity = e?.Destination_City;
              const departureCity = e?.Origin_City;
              const arivalAirport = e?.Destination_Terminal;
              const departureAirport = e?.Origin_Terminal;
              const stops = e?.Stop_Over || 0;

              const isPlaneChange =
                flightNo !== route?.Segments[index + 1]?.Flight_Number;

              let layoverTime = null;
              if (index > 0) {
                const previousFlightArrival = moment(
                  route?.Segments[index - 1]?.Arrival_DateTime,
                  "MM/DD/YYYY HH:mm"
                );
                layoverTime = moment
                  .duration(
                    moment(departureTime, "MM/DD/YYYY HH:mm").diff(
                      previousFlightArrival
                    )
                  )
                  .asMinutes();
              }

              if (index === 0) {
                return (
                  <>
                    <div className="flight-indcator">
                      <span>
                        <h5>
                          {route?.Segments[0]?.Origin_City} →{" "}
                          {
                            route?.Segments[route?.Segments?.length - 1]
                              ?.Destination_City
                          }
                        </h5>
                        {moment(route?.Segments[0]?.Departure_DateTime)?.format(
                          "ddd, MMM Do YYYY"
                        )}
                      </span>
                    </div>
                    <div className="flight-choose">
                      <div className="fight-name">
                        <FlightImage
                          key={e.Airline_Code}
                          flightCode={e.Airline_Code}
                        />
                        {/* <img src={getFlightImage(e?.Airline_Name)} alt="" /> */}
                        <span>
                          <h5>{e?.Airline_Name}</h5>
                          <p>
                            {flightCode} - {flightNo}
                          </p>
                        </span>
                      </div>
                      <div className="flight-duration">
                        <strong>{duration}</strong>
                        {/* <strong>{formatMinToHRAndMin(duration)}</strong> */}
                        {/* <span>{cabinClass}</span> */}
                        <span>
                          {
                            priceDetails?.FareDetails[0]?.FareClasses[index]
                              ?.Class_Desc
                          }
                        </span>
                        <span className="highlight"></span>
                        {/* CB.{classOfBook}{" "} */}
                        {remainingSeats && (
                          <strong
                            className={`${
                              remainingSeats <= 5
                                ? "text-danger"
                                : remainingSeats > 5 && remainingSeats <= 10
                                ? "text-warning"
                                : ""
                            }`}
                          >{`Seats left : ${remainingSeats}`}</strong>
                        )}
                      </div>
                    </div>
                    <div className="route-timing">
                      <div className="route-strating">
                        {moment(departureTime).format("MMM D ddd HH:mm")}
                        <p>
                          <strong className="d-block">{departureCity},</strong>{" "}
                          <span>
                            Terminal{" : "}
                            {departureAirport}
                          </span>
                        </p>
                      </div>
                      <div className="cunsume-time">
                        <p>{stops === 0 ? "Non Stop" : `${stops} Stop`}</p>
                        <div className="cunsume-pic">
                          <img src={PLANE} alt="" />
                        </div>
                      </div>
                      <div className="route-strating route-arrival">
                        {moment(arivalTime).format("MMM D ddd HH:mm")}
                        <p>
                          <strong className="d-block">{arivalCity},</strong>
                          <span>
                            Terminal{" : "}
                            {arivalAirport}
                          </span>
                        </p>
                      </div>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    {layoverTime && (
                      <div className="require">
                        <span>
                          {isPlaneChange ? "Require to change Plane " : ""}
                          layover Time - {formatMinToHRAndMin(layoverTime)}
                        </span>
                      </div>
                    )}
                    <div className="fligt-confir">
                      <div className="flight-choose">
                        <div className="fight-name">
                          <FlightImage
                            key={e.Airline_Code}
                            flightCode={e.Airline_Code}
                          />
                          {/* <img src={getFlightImage(e?.Airline_Name)} alt="" /> */}
                          <span>
                            <h5>{e?.Airline_Name}</h5>
                            <p>
                              {flightCode} - {flightNo}
                            </p>
                          </span>
                        </div>
                        <div className="flight-duration">
                          {/* <strong>{formatMinToHRAndMin(duration)}</strong> */}
                          <strong>{duration}</strong>
                          {/* <span>{cabinClass}</span> */}
                          <span>
                            {
                              priceDetails?.FareDetails[0]?.FareClasses[index]
                                ?.Class_Desc
                            }
                          </span>
                          <span className="highlight"></span>
                          {/* CB.{classOfBook}{" "} */}
                          {remainingSeats && (
                            <strong
                              className={`${
                                remainingSeats <= 5
                                  ? "text-danger"
                                  : remainingSeats > 5 && remainingSeats <= 10
                                  ? "text-warning"
                                  : ""
                              }`}
                            >{`Seats left : ${remainingSeats}`}</strong>
                          )}
                        </div>
                      </div>
                      <div className="route-timing">
                        <div className="route-strating">
                          {moment(departureTime).format("MMM D ddd HH:mm")}
                          <p>
                            <strong className="d-block">
                              {departureCity},
                            </strong>
                            <span>
                              Terminal{" : "}
                              {departureAirport}
                            </span>
                          </p>
                        </div>
                        <div className="cunsume-time">
                          <p>{stops === 0 ? "Non Stop" : `${stops} Stop`}</p>
                          <div className="cunsume-pic">
                            <img src={PLANE} alt="" />
                          </div>
                        </div>
                        <div className="route-strating route-arrival">
                          {moment(arivalTime).format("MMM D ddd HH:mm")}
                          <p>
                            <strong className="d-block">{arivalCity},</strong>
                            <span>
                              Terminal{" : "}
                              {arivalAirport}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
            })}
          </div>
        </div>
        <div
          className="tab-pane fade"
          id={`pills-fare-details-${routeIndex}-${prefix}`}
          role="tabpanel"
          aria-labelledby={`pills-tab-fare-details-${routeIndex}-${prefix}`}
        >
          <div className="flight-summary flight-detail fare-detail">
            <table>
              <tbody>
                <tr>
                  <th>Type</th>
                  <th>Fare</th>
                  <th>Total</th>
                </tr>
                <>
                  {adultBaseRate && ADULT && (
                    <>
                      <tr>
                        <td colSpan={3}>
                          <span>Fare Details for Adult</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Base Price</td>
                        <td>
                          ₹ {formatIndianNumber(adultBaseRate)} x{" "}
                          {formatIndianNumber(ADULT)}
                        </td>
                        <td>₹ {formatIndianNumber(adultBaseRate * ADULT)}</td>
                      </tr>
                      <tr>
                        <td>Taxes and fee</td>
                        <td>
                          ₹ {formatIndianNumber(adultTaxRate)} x{" "}
                          {formatIndianNumber(ADULT)}
                        </td>
                        <td>₹ {formatIndianNumber(adultTaxRate * ADULT)}</td>
                      </tr>
                    </>
                  )}
                  {childBaseRate > 0 && CHILD > 0 && (
                    <>
                      <tr>
                        <td colSpan={3}>
                          <span>Fare Details for Child</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Base Price</td>
                        <td>
                          {" "}
                          ₹ {formatIndianNumber(childBaseRate)} x{" "}
                          {formatIndianNumber(CHILD)}
                        </td>
                        <td>₹ {formatIndianNumber(childBaseRate * CHILD)}</td>
                      </tr>
                      <tr>
                        <td>Taxes and fee</td>
                        <td>
                          {" "}
                          ₹ {formatIndianNumber(childTaxRate)} x{" "}
                          {formatIndianNumber(CHILD)}
                        </td>
                        <td>₹ {formatIndianNumber(childTaxRate * CHILD)}</td>
                      </tr>
                    </>
                  )}
                  {infantBaseRate > 0 && INFANT > 0 && (
                    <>
                      <tr>
                        <td colSpan={3}>
                          <span>Fare Details for Infant</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Base Price</td>
                        <td>
                          {" "}
                          ₹ {formatIndianNumber(infantBaseRate)} x{" "}
                          {formatIndianNumber(INFANT)}
                        </td>
                        <td>₹ {formatIndianNumber(infantBaseRate * INFANT)}</td>
                      </tr>
                      <tr>
                        <td>Taxes and fee</td>
                        <td>
                          {" "}
                          ₹ {formatIndianNumber(infantTaxRate)} x{" "}
                          {formatIndianNumber(INFANT)}
                        </td>
                        <td>₹ {formatIndianNumber(infantTaxRate * INFANT)}</td>
                      </tr>
                    </>
                  )}
                </>
                <tr>
                  <td colSpan={2}>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>₹ {formatIndianNumber(totalPrice)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* <div
          className="tab-pane fade position-relative min-height-150"
          id={`pills-fare-rules-${routeIndex}-${prefix}`}
          role="tabpanel"
          aria-labelledby={`pills-tab-fare-rulesd-${routeIndex}-${prefix}`}
        >
          <Loading loading={fareRulesLoading} />
          {!fareRulesLoading && (
            <>
              {fareRule && fareRule?.length <= 0 ? (
                <h4 className="text-center">
                  No Fare Rule Found. Please contact Customer Care!!!
                </h4>
              ) : (
                <div className="flight-cancel flight-detail flight-table">
                  <h5>
                    {route?.Segments[0]?.Origin_City} {" to "}
                    {
                      route?.Segments[route?.Segments?.length - 1]
                        ?.Destination_City
                    }
                  </h5>
                  <span className="mention-tag">
                    Mentioned fees are Per Pax Per Sector <br /> Apart from
                    airline charges, GST + RAF + applicable charges if any, will
                    be charged.
                  </span>
                  <div style={{ maxHeight: 400, overflow: "auto" }}>
                    {Array.isArray(fareRule) &&
                      fareRule?.map((e: any) => {
                        return (
                          <div
                            style={{ padding: "0 10px" }}
                            dangerouslySetInnerHTML={{
                              __html: e?.FareRuleDesc ?? "",
                            }}
                          />
                        );
                      })}
                  </div>
                  <span> *From the Time of Departure</span>
                </div>
              )}
            </>
          )}
        </div> */}
        <div
          className="tab-pane fade"
          id={`pills-buggage-details-${routeIndex}-${prefix}`}
          role="tabpanel"
          aria-labelledby={`pills-tab-buggage-details-${routeIndex}-${prefix}`}
        >
          <div className="flight-cancel flight-detail">
            <table>
              <tbody>
                <tr>
                  <th>Sector</th>
                  <th>Check In Baggage</th>
                  <th>Hand Baggage</th>
                  <th>Remarks</th>
                </tr>
                {route?.Segments?.map((e: any) => {
                  const departureCode = e?.Origin;
                  const arivalCode = e?.Destination;
                  return (
                    <tr>
                      <td>
                        {departureCode}-{arivalCode}
                      </td>
                      <td>
                        {adultFreeBaggage?.Check_In_Baggage
                          ? "Adult: " + adultFreeBaggage?.Check_In_Baggage
                          : ""}
                        {childFreeBaggage?.Check_In_Baggage
                          ? ", Child: " + childFreeBaggage?.Check_In_Baggage
                          : ""}
                        {infantFreeBaggage?.Check_In_Baggage
                          ? ", Infant: " + infantFreeBaggage?.Check_In_Baggage
                          : ""}
                      </td>
                      <td>
                        {adultFreeBaggage?.Hand_Baggage
                          ? "Adult: " + adultFreeBaggage?.Hand_Baggage
                          : ""}
                        {childFreeBaggage?.Hand_Baggage
                          ? ", Child: " + childFreeBaggage?.Hand_Baggage
                          : ""}
                        {infantFreeBaggage?.Hand_Baggage
                          ? ", Infant: " + infantFreeBaggage?.Hand_Baggage
                          : ""}
                      </td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: `
      ${
        adultFreeBaggage?.DisplayRemarks
          ? "Adult: " + adultFreeBaggage?.DisplayRemarks
          : ""
      }
      ${
        childFreeBaggage?.DisplayRemarks
          ? ", Child: " + childFreeBaggage?.DisplayRemarks
          : ""
      }
      ${
        infantFreeBaggage?.DisplayRemarks
          ? ", Infant: " + infantFreeBaggage?.DisplayRemarks
          : ""
      }
    `,
                        }}
                      ></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <span>*From the Time of Departure</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightRDetailsTabs;
